import { SelectOption } from 'v2/types';

export enum SearchType {
  File = 'file',
  Folder = 'folder',
}

export const options: SelectOption<SearchType>[] = [
  { id: 'file', label: 'File', value: SearchType.File },
  { id: 'folder', label: 'Folder', value: SearchType.Folder },
];
